import template from './general_documents_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class GeneralDocumentsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class GeneralDocumentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new GeneralDocumentsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'GeneralDocumentsHelp',
	dialog_class: GeneralDocumentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/general_documents_help',
	provider: 'ps'
};
